<mat-expansion-panel class="checklist-expansion-panel" [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title class="checklist-title">
      <mat-icon class="info-icon" [glxyTooltip]="checklistTooltipText" [tooltipPositions]="positions">
        info_outline
      </mat-icon>
      {{ 'CHECKLIST.TITLE' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ul class="checklist-ul">
    <li class="checklist-li" *ngFor="let wo of workOrders">
      <mat-icon *ngIf="wo.status === FULFILLMENT_ORDER_STATUS_DETAILS_NEEDED; else checkedIcon">
        radio_button_unchecked
      </mat-icon>

      <ng-template #checkedIcon>
        <mat-icon class="checked-icon-checklist">check_circle</mat-icon>
      </ng-template>

      <a class="checklist-a" (click)="handleChecklistClick(wo.appId)">
        {{ wo.appInfo.appName | translate }}
      </a>
    </li>
  </ul>
</mat-expansion-panel>
